module.exports = __webpack_public_path__ + "img/40_69_001_640.5b0b7fc5.jpg";